export const styles = theme => ({
    contentWrapper: {
        [theme.breakpoints.mdDown]:{
            "&:not(.navbar-less)":{
                marginTop: 125,
            }
        }
    }
})